import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { displayNamesOfEventTypes } from 'src/consumer/constants'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import './LoaderComponent.css'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

// new stuff components:

export const PastBookingsHorizontalComponent = ({
  patientId,
  clinicId,
  pastPatientBookingsApiSignature = null, // If null, will use new API
}) => {
  const [loading, setLoading] = useState(false)
  const [bookings, setBookings] = useState([])

  async function getPreviousBooking() {
    if (!patientId) return

    setLoading(true)
    try {
      // Use new API endpoint if no custom signature provided
      const apiEndpoint = pastPatientBookingsApiSignature || '/api/secure/cc/support/events/booked-slots/patient'
      
      // Determine if we should use the new API (cc/support) or old API
      const useNewAPI = !pastPatientBookingsApiSignature || apiEndpoint.includes('/api/secure/cc/support/')
      
      let response
      
      if (useNewAPI) {
        // Use new API with getSPDataWithParams
        const roles = getAllRolesInBoolean()
        const params = {
          patientId,
          sortDescendingOnStartTime: true,
          limit: 100,
        }
        
        // Add clinicId if provided
        if (clinicId) {
          params.clinicId = clinicId
        }
        
        // For L2 support, we can optionally filter by serviceTypes
        // For now, we'll get both therapy and screening (default behavior)
        // If needed, this can be made configurable later
        if (roles.isL2TherapySupport) {
          // L2 users can filter, but we'll get both by default
          // params.serviceTypes = 'therapy,screening' // Uncomment to filter
        }
        
        response = await getSPDataWithParams(apiEndpoint, params)
      } else {
        // Fallback to old API for backward compatibility
        response = await getCPDataWithoutParams(
          `${pastPatientBookingsApiSignature}?patientId=${patientId}&clinicId=${clinicId}&sortDescendingOnStartTime=true`,
        )
      }
      
      setLoading(false)
      
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        Array.isArray(response?.data?.data?.['booked-event-info'])
      ) {
        setBookings(
          response?.data?.data?.['booked-event-info']?.filter((item) => item?.status === 'booked'),
        )
      }
    } catch (error) {
      console.error('Error fetching patient bookings:', error)
      setLoading(false)
    }
  }

  console.log(bookings)

  useEffect(() => {
    getPreviousBooking()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, clinicId])

  return (
    <div style={{ position: 'relative', width: '100%', overflowX: 'auto' }}>
      {loading ? (
        <Spinner variant="dark" size="sm" />
      ) : bookings?.length > 0 ? (
        <>
          <div style={{ fontSize: '16px', fontWeight: '700' }}>Booking History:</div>
          <div
            style={{
              padding: '8px',
              display: 'flex',
              direction: 'row-reverse',
              gap: '48px',
            }}
          >
            <hr style={{ width: '100%', position: 'absolute', top: '50%' }} />
            {bookings?.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="d-flex flex-column justify-content-center align-items-center"
                  style={{ background: 'white', zIndex: 1, padding: '0 8px', flexShrink: 0 }}
                >
                  <div style={{ fontSize: '12px' }}>
                    {displayNamesOfEventTypes[item?.eventType]}
                  </div>
                  <div style={{ fontSize: '12px' }}>
                    {dayjs?.utc(item?.startTime)?.local()?.format('DD MMM YY, h:mm a')}
                  </div>
                  <div style={{ fontSize: '12px' }}>with {item?.mentorName}</div>
                </div>
              )
            })}
          </div>
        </>
      ) : (
        <>
          <b>Past Bookings: </b>
          {' No past bookings found'}
        </>
      )}
    </div>
  )
}
